module.exports = __webpack_public_path__ + "media/welcome_record_new.d8368aa6.mp3";